import { TargetLayer } from 'business/models/CustomModels';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import {
  DropLayerFragment,
  FragmentLayerDTO,
  LayerDTO,
  WellIngDTO,
} from 'business/models/Models';
import { LayerType } from 'utils/Global';
import {
  findWellsInLayer,
  createTargetLayer,
  updateDropByTargetLayer,
} from './GenerateCommon';
import { Compute } from './VolCalculator';

export function FragmentLayerGenerate(docData: ExperimentDtoClient, lyr: LayerDTO) {
  let fragmentLayer: FragmentLayerDTO;
  if (lyr.type != LayerType.Fragment) {
    return;
  } else {
    fragmentLayer = lyr.layerDetail as FragmentLayerDTO;
  }

  const layerWidth: number = lyr.width + 1;
  const layerHeight: number = lyr.height + 1;
  const fragmentScreenList = fragmentLayer?.fragmentScreen?.fragmentFragmentScreen || [];
  const totalConditions = fragmentScreenList.length;

  let fragmentScreenIndex = 0;

  const wells: WellIngDTO[][] = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );

  for (let i = 0; i < layerHeight; i++) {
    for (let j = 0; j < layerWidth; j++) {
      const targetLayer: TargetLayer = createTargetLayer(lyr, wells[i][j]);
      targetLayer.volume = fragmentLayer?.volume ?? 0;
      targetLayer.waterVolume = 0;
      Compute(targetLayer, lyr, docData);

      const hasFragmentToAssign = fragmentScreenIndex < totalConditions;
      const currentFragment = hasFragmentToAssign
        ? fragmentScreenList[fragmentScreenIndex]
        : null;
      const fragmentConc = currentFragment?.concentration ?? 0;

      if (!hasFragmentToAssign || fragmentConc <= 0) {
        if (hasFragmentToAssign) {
          fragmentScreenIndex++;
        }
        continue;
      }

      const drop = updateDropByTargetLayer(lyr, targetLayer, wells[i][j]);
      drop.waterVolume += targetLayer.waterVolume;

      const dropLayer = drop.dropLayerList?.find(
        (dropLayer) => dropLayer.layer?.id === lyr.id,
      );

      if (!dropLayer) {
        continue;
      }

      const existingFragment = dropLayer.dropLayerFragmentList?.some(
        (dropLayerFragment) => dropLayerFragment.wellDropLayerId === lyr.id,
      );

      if (!existingFragment) {
        const dropFragment = new DropLayerFragment({
          concentration: fragmentConc,
          wellDropLayerId: lyr.id,
          id: 0,
          fragmentId: currentFragment.fragmentId,
          source: '',
        });

        dropLayer.dropLayerFragmentList = dropLayer.dropLayerFragmentList || [];
        dropLayer.dropLayerFragmentList.push(dropFragment);

        drop.isFragmentDrop = true;
        drop.fragmentScreenId = fragmentLayer.fragmentScreenId;
        drop.dropFragmentVolume = fragmentLayer.volume;
      }

      fragmentScreenIndex++;
    }
  }
}
